import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { Breakpoint } from '@icilalune/utils/responsive';

export const UI_BREAKPOINT = new InjectionToken<Observable<Breakpoint>>(
  'UI_BREAKPOINT'
);
